import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
} from '@angular/core';
import { AllHelpTooltipMaps } from '@sidkik/global';

@Component({
  selector: 'sidkik-tab',
  template: `
    <div [hidden]="!active" class="tw-mt-2 tw-w-full tw-h-full">
      <ng-content></ng-content>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabComponent {
  @Input() title = '';
  @Input() active = false;
  @Input() infoBadgeCount = -1;
  @Input() warnBadgeCount = -1;
  @Input() errorBadgeCount = -1;
  @Input() draggable = false;
  @Input() showHelpIcon = false;
  @Input() tooltipKey: AllHelpTooltipMaps | undefined;
  @Input() showDelay = 1000;

  constructor(private changeDetectionRef: ChangeDetectorRef) {}

  // force a change detection
  public markForCheck() {
    this.changeDetectionRef.detectChanges();
  }
}
